import styled from 'styled-components'

export const BottomNav = styled.footer`
  .sponsors {
    img {
      width: 100%;
      /* height: 100px;
      object-fit: contain; */
    }
  }
  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 140px;
    padding: 1em;
  }
  .left {
    background: #f0f0f0;
  }
  .right {
    background: white;
    gap: 2em;
    flex-wrap: wrap;
  }
  .logo {
    width: 200px;
  }
  a {
    display: block;
    font-size: 0.8em;
    color: var(--bs-danger);
  }
`
